import { Box, Typography } from "@mui/material";
import React from "react";
import CardServices from "./CardServices";
//import Carrusel from "../common/Carrusel";
import imgPortfolioBg from './img/portafolio.jpeg'

import imgDt from './img/services/driveTest_ast8ul.png'
import imgSiteS from './img/services/SiteSurvey_du7p42.jpg'
import imgPostP from './img/services/PostProceso_xzzeta.jpg'
import imgBusqS from './img/services/BusquedaSitios_qfuxqy.jpg'
import imgViabT from './img/services/ViabilidadDeTransmision_xvhpyj.jpg'
import imgEstD  from './img/services/EstudiosConDrones_rgba7t.jpg'
import imgSimRf  from './img/services/SimulacionesDeRadioFrecuencia_qbdboe.jpg'
import imgOptRf  from './img/services/OptimizacionRf_nlogs6.jpg'
import imgIbs  from './img/services/IBS_o5mijx.jpg'

const imgServices= [
  {
    id:1,
    title: "DRIVE TEST OUTDOOR",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671656208/evotech/Portfolio/driveTest_ast8ul.png",
    imgPath: imgDt,
    description: "Proporciona mediciones de voz y datos en las diferentes tecnologías, para mostrar al cliente final, donde hay deficiencia de cobertura o fallas en el servicio."
  },
  {
    id:2,
    title: "OPTIMIZACIÓN RF",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671571517/evotech/Portfolio/SiteSurvey_du7p42.jpg",
    imgPath: imgSiteS,
    description: "La optimización de los sitios se logra haciendo cambios físicos azimut, tilt eléctrico, tilt mecánico y cambio de altura de antenas."
},
  {
    id:3,
    title: "POST PROCESO",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671571517/evotech/Portfolio/PostProceso_xzzeta.jpg",
    imgPath: imgPostP,
    description: "Permite analizar a profundidad los datos recolectados luego de llevar a cabo el proceso de drive test, esto le permite al cliente final identificar y corregir falencias en cobertura, accesibilidad y continuidad del servicio."
  },
  {
    id:4,
    title: "BUSQUEDA DE SITIOS",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671571517/evotech/Portfolio/BusquedaSitios_qfuxqy.jpg",
    imgPath: imgBusqS,
    description: "Para la busqueda de sitios es importante tener en cuenta aspectos legales, eléctricos, de ingenieria civil y de radiofrecuencia, ofrecemos una solución integral o parcial para estas necesidades."
  },
  {
    id:5,
    title: "VIABILIDAD DE TRANSMISIÓN",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671571517/evotech/Portfolio/ViabilidadDeTransmisi%C3%B3n_xvhpyj.jpg",
    imgPath: imgViabT,
    description: "Para este servicio se comprueban líneas de vista a través de software especializados."
  },
  {
    id:6,
    title: "ESTUDIOS CON DRONES",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671571517/evotech/Portfolio/EstudiosConDrones_rgba7t.jpg",
    imgPath: imgEstD,
    description: "Estos son utilizadas para viabilidad de búsqueda de sitios y verificación de torres."
  },
  {
    id:7,
    title: "SIMULACIONES DE RADIOFRECUENCIA",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671571517/evotech/Portfolio/SimulacionesDeRadioFrecuencia_qbdboe.jpg",
    imgPath: imgSimRf,
    description: "Mediante herramientas apropiadas como cartografía y software especializado, usando parametros adecuados, con modelos de propagación y cartografía."
  },
  {
    id:8,
    title: "SITE SURVEY",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671571516/evotech/Portfolio/Optimizaci%C3%B3nRf_nlogs6.jpg",
    imgPath: imgOptRf,
    description: "Las inspecciones de campo (Site Survey) en el área donde se formule su proyecto, se harán para grantizar la recolección de la información más precisa para la planeación, diseño o desarrollo del mismo."
  },
  {
    id:9,
    title: "IBS (In Building solution)",
    //imgPath: "https://res.cloudinary.com/dzkp92nfz/image/upload/v1671642316/evotech/Portfolio/IBS_o5mijx.jpg",
    imgPath: imgIbs,
    description: "Proporciona cobertura en interiores, utilizando un sistema de antenas distribuidas, las cuales permiten mejor conectividad, para esto ofrecemos servicio de planeación, implementación, monitoreo de antes y después del proyecto."
  
  }
]

const Portfolio = () => {
  return (
    <div 
      style={{
        //backgroundImage: `url(https://res.cloudinary.com/dzkp92nfz/image/upload/v1670581777/evotech/Portfolio/portafolio_vkloeo.jpg)`,
        backgroundImage: `url(${imgPortfolioBg})`,
        width: "100%",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        //height:{xs:"300vh", lg:"141vh"}
      }}
      >

      <div>
        <Typography gutterBottom variant="h4" 
          component="div"
          sx={{
            pt: {xs:"36px", sm:"40px"},
            textAlign:{xs:"center"},
            color: "white"
            //</div>m: {xs:"0-auto", sm:"40px"}
          }}
        >
          Nuestros Servicios
        </Typography>            
      
        <Box 
          sx={{
            maxWidth: {xs:"620px", sm:"885px", md:"1140px", lg:"1350px"},
            m: {xs: '0 auto', sm:"0 10px 0px 0px"},
            backgroundColor: "transparent",
            display:{ xs: "flex", lg:"flex" },
            justifyContent:{xs:"center", sm:"end", lg:"end"},
            flexWrap:{xs:"wrap"},
            pt:"10px",
            //height: {md:"248vh"},
            //mr:"10px",
            //pl:"10px",
            //border: "solid 2px red",
          }}>
              {
                imgServices.map(imag => (
                  <CardServices imag={imag} key={imag.title}/>
                ))
              }
            
        </Box>
      </div>

    </div>
  );
};

export default Portfolio;
